import type { FC } from "react";

export const DesktopIcon = () => {
  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.5 18.5H14.5M10.5 18.5H6.5M10.5 18.5V14.5M10.5 14.5C14.5 14.5 18 14.1667 18.5 13.8333C19 13.5 19.5 10.6667 19.5 8C19.5 5.33333 19 2.5 18.5 2.16667C18 1.83333 14.5 1.5 10.5 1.5C6.5 1.5 3 1.83333 2.5 2.16667C2 2.5 1.5 5.33333 1.5 8C1.5 10.6667 2 13.5 2.5 13.8333C3 14.1667 6.5 14.5 10.5 14.5Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const DownloadIcon = () => {
  return (
    <svg
      width="14"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18 13V16.5C18 19.5577 14 19.5 10 19.5C6 19.5 2 19.5577 2 16.5V13M10 14L10 2M10 14L6 10M10 14L14 10"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const UploadIcon = () => {
  return (
    <svg
      width="14"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18 12V16.5C18 19.5577 14 19.5 10 19.5C6 19.5 2 19.5577 2 16.5V12M10 2L10 14M10 2L14 6M10 2L6 6"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ClassroomIcon = () => {
  return (
    <svg
      width="31"
      height="22"
      viewBox="0 0 31 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24.7273 13.8571C27.6393 13.8571 30 16.7143 30 18.8571C30 20.0406 29.1147 21 28.0227 21H27.3636M22.0909 9.57143C24.2749 9.57143 26.0455 7.65265 26.0455 5.28571C26.0455 2.91878 24.2749 1 22.0909 1M6.27273 13.8571C3.36068 13.8571 1 16.7143 1 18.8571C1 20.0406 1.88526 21 2.97727 21H3.63636M8.90909 9.57143C6.72506 9.57143 4.95455 7.65265 4.95455 5.28571C4.95455 2.91878 6.72506 1 8.90909 1M21.4318 21H9.56818C8.47616 21 7.59091 20.0406 7.59091 18.8571C7.59091 15.2857 11.5455 13.8571 15.5 13.8571C19.4545 13.8571 23.4091 15.2857 23.4091 18.8571C23.4091 20.0406 22.5238 21 21.4318 21ZM19.4545 5.28571C19.4545 7.65265 17.684 9.57143 15.5 9.57143C13.316 9.57143 11.5455 7.65265 11.5455 5.28571C11.5455 2.91878 13.316 1 15.5 1C17.684 1 19.4545 2.91878 19.4545 5.28571Z"
        stroke="white"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const CompetitionsIcon = () => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5 14H18.5858C19.4767 14 19.9229 12.9229 19.2929 12.2929L16.7071 9.70711C16.3166 9.31658 16.3166 8.68342 16.7071 8.29289L19.2929 5.70711C19.9229 5.07714 19.4767 4 18.5858 4H5V14ZM5 14V21"
        stroke="white"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const FlagIcon = () => {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.8335 58.3327H77.4409C81.153 58.3327 83.0121 53.8446 80.3872 51.2197L69.6131 40.4456C67.9859 38.8184 67.9859 36.1803 69.6131 34.5531L80.3872 23.779C83.0121 21.1541 81.153 16.666 77.4409 16.666H20.8335V58.3327ZM20.8335 58.3327V87.4993"
        stroke="currentColor"
        strokeWidth="6.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ReportsIcon = () => {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16 16V12M12 16V8M8 16V14M3.5 12C3.5 5.5 5.5 3.5 12 3.5C18.5 3.5 20.5 5.5 20.5 12C20.5 18.5 18.5 20.5 12 20.5C5.5 20.5 3.5 18.5 3.5 12Z"
        stroke="#FCFDFF"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const CirclePower = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="28"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <circle cx="12" cy="12" r="10" />
      <path d="M12 12V7" />
      <path d="M16 9a5 5 0 1 1-8 0" />
    </svg>
  );
};

export const HomeIcon = () => {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 108 109"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M75.1836 90.8346H34.3378C25.3144 90.8346 17.9995 83.322 17.9995 74.0551V47.6593C17.9995 41.7918 20.9837 36.3505 25.8696 33.3094L46.2925 20.5977C51.4975 17.3581 58.0239 17.3581 63.2288 20.5977L83.6517 33.3094C88.5377 36.3505 91.5219 41.7918 91.5219 47.6593V74.0551C91.5219 83.322 84.2068 90.8346 75.1836 90.8346Z"
        stroke="currentColor"
        strokeWidth="8.28723"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M42.5112 74.0547H67.0187"
        stroke="currentColor"
        strokeWidth="8.28723"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const FileIcon = () => {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 9 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.125 5.95801H4.95833M3.125 7.79134H5.875M4.99106 1.15892V3.13162C4.99106 3.63788 5.40147 4.04829 5.90773 4.04829H7.86849M4.99106 1.15892C4.83492 1.14986 4.67133 1.14551 4.5 1.14551C1.87132 1.14551 1.0625 2.17002 1.0625 5.49967C1.0625 8.82933 1.87132 9.85384 4.5 9.85384C7.12868 9.85384 7.9375 8.82933 7.9375 5.49967C7.9375 4.95636 7.91596 4.47442 7.86849 4.04829M4.99106 1.15892L7.86849 4.04829"
        stroke="currentColor"
        strokeWidth="0.6875"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const AssessmentIcon = () => {
  return (
    <svg
      width="11"
      height="12"
      viewBox="0 0 11 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.69856 9.84377H9.59439M6.61516 2.84375L2.49087 7.34298C2.18899 7.6723 1.95064 8.07205 1.87808 8.53101C1.80482 8.99442 1.78044 9.56951 2.03183 9.84375C2.28322 10.118 2.81038 10.0914 3.23517 10.0115C3.65589 9.93232 4.02233 9.6723 4.32421 9.34298L8.4485 4.84375M6.61516 2.84375C6.61516 2.84375 7.99016 1.34375 8.90683 2.34375C9.8235 3.34375 8.4485 4.84375 8.4485 4.84375M6.61516 2.84375L8.4485 4.84375"
        stroke="#FAFBFF"
        strokeWidth="0.85"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const Logout = (size?: number, className?: string) => {
  return (
    <svg
      className={className}
      width={size || "1em"}
      height={size || "1em"}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14 4L17.5 4C20.5577 4 20.5 8 20.5 12C20.5 16 20.5577 20 17.5 20H14M3 12L15 12M3 12L7 8M3 12L7 16"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const NotificationIcon: FC<{ size?: number; className?: string }> = ({
  size,
  className,
}) => {
  return (
    <svg
      className={className}
      width={size || "1em"}
      height={size || "1em"}
      viewBox="0 0 17 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.49884 15.5V16.5C5.49884 18.1569 6.84199 19 8.49884 19C10.1557 19 11.4988 18.1569 11.4988 16.5V15.5M2.49883 6.5C2.49883 3.18629 5.18512 1.5 8.49883 1.5C11.8125 1.5 14.4988 3.18629 14.4988 6.5C14.4988 8.43916 15.2039 10.6133 15.9304 12.3389C16.5336 13.7717 15.521 15.5 13.9664 15.5H3.03121C1.47662 15.5 0.464023 13.7717 1.06726 12.3389C1.79377 10.6133 2.49883 8.43916 2.49883 6.5Z"
        stroke="#F6FBFF"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const PeopleIcon = () => {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 107 71"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M85.1306 44.5653C95.0877 44.5653 103.16 53.5798 103.16 60.3407C103.16 64.0746 100.133 67.1016 96.3987 67.1016H94.1451M76.1161 31.0435C83.5839 31.0435 89.6378 24.9896 89.6378 17.5218C89.6378 10.0539 83.5839 4 76.1161 4M22.029 44.5653C12.0719 44.5653 4 53.5798 4 60.3407C4 64.0746 7.02695 67.1016 10.7609 67.1016H13.0145M31.0435 31.0435C23.5757 31.0435 17.5218 24.9896 17.5218 17.5218C17.5218 10.0539 23.5757 4 31.0435 4M73.8624 67.1016H33.2972C29.5632 67.1016 26.5363 64.0746 26.5363 60.3407C26.5363 49.0725 40.058 44.5653 53.5798 44.5653C67.1016 44.5653 80.6233 49.0725 80.6233 60.3407C80.6233 64.0746 77.5964 67.1016 73.8624 67.1016ZM67.1016 17.5218C67.1016 24.9896 61.0477 31.0435 53.5798 31.0435C46.1119 31.0435 40.058 24.9896 40.058 17.5218C40.058 10.0539 46.1119 4 53.5798 4C61.0477 4 67.1016 10.0539 67.1016 17.5218Z"
        stroke="currentColor"
        strokeWidth="6.76088"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const NetworkIcon = () => {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.68439 10.6578L15.3124 7.34378M15.3156 16.6578L8.69379 13.3469M21 6C21 7.65685 19.6569 9 18 9C16.3431 9 15 7.65685 15 6C15 4.34315 16.3431 3 18 3C19.6569 3 21 4.34315 21 6ZM9 12C9 13.6569 7.65685 15 6 15C4.34315 15 3 13.6569 3 12C3 10.3431 4.34315 9 6 9C7.65685 9 9 10.3431 9 12ZM21 18C21 19.6569 19.6569 21 18 21C16.3431 21 15 19.6569 15 18C15 16.3431 16.3431 15 18 15C19.6569 15 21 16.3431 21 18Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
    </svg>
  );
};

export const CodeIcon = () => {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17 8C17 8 17.8 8.33333 19.2 9.66667C20.6 11 21 12 21 12C21 12 20.6 13 19.2 14.3333C17.8 15.6667 17 16 17 16"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 16C9 16 8.2 15.6667 6.8 14.3333C5.4 13 5 12 5 12C5 12 5.4 11 6.8 9.66667C8.2 8.33333 9 8 9 8"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.9753 5.95293C14.9753 5.95293 13.3236 10.4877 12.9983 11.5C12.673 12.5124 11.3044 17.3777 11.3044 17.3777"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const CogIcon = () => {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="flex-none"
    >
      <path
        d="M9.5 1H11.5C12.0523 1 12.5 1.44772 12.5 2V2.56879C12.5 2.99659 12.7871 3.36825 13.1822 3.53228C13.5775 3.69638 14.0377 3.63384 14.3403 3.33123L14.7426 2.92891C15.1331 2.53838 15.7663 2.53838 16.1568 2.92891L17.571 4.34312C17.9616 4.73365 17.9615 5.36681 17.571 5.75734L17.1688 6.1596C16.8661 6.46223 16.8036 6.92247 16.9677 7.31774C17.1317 7.71287 17.5034 8 17.9313 8L18.5 8C19.0523 8 19.5 8.44771 19.5 9V11C19.5 11.5523 19.0523 12 18.5 12H17.9312C17.5034 12 17.1318 12.2871 16.9677 12.6822C16.8036 13.0775 16.8661 13.5377 17.1688 13.8403L17.571 14.2426C17.9616 14.6331 17.9616 15.2663 17.571 15.6568L16.1568 17.071C15.7663 17.4616 15.1331 17.4616 14.7426 17.071L14.3403 16.6688C14.0377 16.3661 13.5775 16.3036 13.1822 16.4677C12.7871 16.6318 12.5 17.0034 12.5 17.4312V18C12.5 18.5523 12.0523 19 11.5 19H9.5C8.94772 19 8.5 18.5523 8.5 18V17.4313C8.5 17.0034 8.21287 16.6317 7.81774 16.4677C7.42247 16.3036 6.96223 16.3661 6.6596 16.6688L6.25732 17.071C5.86679 17.4616 5.23363 17.4616 4.84311 17.071L3.42889 15.6568C3.03837 15.2663 3.03837 14.6331 3.42889 14.2426L3.83123 13.8403C4.13384 13.5377 4.19638 13.0775 4.03228 12.6822C3.86825 12.2871 3.49659 12 3.06879 12H2.5C1.94772 12 1.5 11.5523 1.5 11V9C1.5 8.44772 1.94772 8 2.5 8L3.06877 8C3.49658 8 3.86825 7.71288 4.03229 7.31776C4.1964 6.9225 4.13386 6.46229 3.83123 6.15966L3.42891 5.75734C3.03838 5.36681 3.03838 4.73365 3.42891 4.34313L4.84312 2.92891C5.23365 2.53839 5.86681 2.53839 6.25734 2.92891L6.65966 3.33123C6.96228 3.63386 7.4225 3.6964 7.81776 3.53229C8.21288 3.36825 8.5 2.99658 8.5 2.56876V2C8.5 1.44772 8.94772 1 9.5 1Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path
        d="M12.5 10C12.5 11.1046 11.6046 12 10.5 12C9.39543 12 8.5 11.1046 8.5 10C8.5 8.89543 9.39543 8 10.5 8C11.6046 8 12.5 8.89543 12.5 10Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
    </svg>
  );
};

export const ChevronRight: FC<{ className?: string }> = ({ className }) => {
  return (
    <svg
      className={className}
      width={13}
      height={13}
      viewBox="0 0 10 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 17.5L9 9.5L1 1.5"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const BackIconCircle = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5 10H15M5 10L9 6M5 10L9 14M19 10C19 14.9706 14.9706 19 10 19C5.02944 19 1 14.9706 1 10C1 5.02944 5.02944 1 10 1C14.9706 1 19 5.02944 19 10Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ChevronRightToggle = () => {
  return (
    <svg
      width="8"
      height="16"
      viewBox="0 0 8 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.27778 0.999999L6.72222 1C7.15178 1 7.5 1.69642 7.5 2.55556L7.5 13.4444C7.5 14.3036 7.15178 15 6.72222 15L1.27778 15C0.848211 15 0.5 14.3036 0.5 13.4444L0.500001 2.55555C0.500001 1.69642 0.848212 0.999999 1.27778 0.999999Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.01562 11L5.01563 8L3.01563 5"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const ModuleIcon = () => {
  return (
    <svg
      width="15"
      height="16"
      viewBox="0 0 15 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.9405 15H2.05165C1.19254 15 0.496094 14.3036 0.496094 13.4444V2.55556C0.496094 1.69645 1.19254 1 2.05165 1H12.9405C13.7997 1 14.4961 1.69645 14.4961 2.55556V13.4444C14.4961 14.3036 13.7997 15 12.9405 15Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.80252 6.44434L2.44141 7.99989L3.80252 9.55545"
        fill="transparent"
      />
      <path
        d="M3.80252 6.44434L2.44141 7.99989L3.80252 9.55545"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M5.55078 15V1V15Z" fill="transparent" />
      <path
        d="M5.55078 15V1"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const PublishIcon = () => {
  return (
    <svg
      width="14"
      height="23"
      viewBox="0 0 20 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5 7V6C5 3.23858 7.23858 1 10 1C12.7614 1 15 3.23858 15 6V7C17.2091 7 19 8.79086 19 11C19 12.4806 18.1956 13.8084 17 14.5M5 7C2.79086 7 1 8.79086 1 11C1 12.4806 1.8044 13.8084 3 14.5M5 7C5.43285 7 5.84965 7.06875 6.24006 7.19594M10 9V18M10 9L13 12M10 9L7 12"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const UserCode = () => {
  return (
    <svg
      width="18"
      height="20"
      viewBox="0 0 18 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 9C12 10.6569 10.6569 12 9 12C7.34315 12 6 10.6569 6 9M1 5H17M1 5V11C1 17.3668 2.12797 18.5 9 18.5C15.872 18.5 17 17.3668 17 11V5M1 5L2.44721 2.10557C2.786 1.428 3.47852 1 4.23607 1H13.7639C14.5215 1 15.214 1.428 15.5528 2.10557L17 5"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const DangerIcon = ({ size }: { size?: number }) => {
  return (
    <svg
      width={size || "20"}
      height={size || "63"}
      viewBox="0 0 20 63"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.6875 53.1562C19.6875 58.5841 15.2716 63 9.84375 63C4.41591 63 0 58.5841 0 53.1562C0 47.7284 4.41591 43.3125 9.84375 43.3125C15.2716 43.3125 19.6875 47.7284 19.6875 53.1562ZM1.13941 3.10066L2.81285 36.5694C2.89148 38.1411 4.18864 39.375 5.76229 39.375H13.9252C15.4989 39.375 16.796 38.1411 16.8746 36.5694L18.5481 3.10066C18.6324 1.41381 17.2876 0 15.5987 0H4.08885C2.39991 0 1.05513 1.41381 1.13941 3.10066Z"
        fill="currentColor"
        stroke="currentColor"
      />
    </svg>
  );
};

export const CodeFolder = ({ size }: { size?: number }) => {
  return (
    <svg
      width={size || "24"}
      height={size || "24"}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23.352 8.79168C22.9142 8.23776 22.2998 7.896 21.5952 7.80576C21.2275 6.14496 19.8912 4.93248 18.3014 4.93248H11.5469C10.5667 4.79808 10.2874 4.51584 10.1386 4.04928C9.75264 2.3712 8.4048 1.20288 6.85056 1.20288H3.40128C1.52544 1.20288 0 2.90592 0 4.99968V19.0003C0 19.8202 0.2304 20.5978 0.66528 21.2544C0.75648 21.4435 0.86496 21.6221 0.9936 21.7853C1.50912 22.4371 2.26848 22.7971 3.13248 22.7971H18.2995C19.3296 22.7971 20.2838 22.2883 20.9318 21.3994C21.4915 20.7926 21.9178 20.0285 22.1174 19.1894L23.8819 11.7667C24.1498 10.6416 23.9558 9.5568 23.351 8.79168H23.352ZM3.40032 2.83488H6.8496C7.64352 2.83488 8.34336 3.49344 8.55168 4.43712L8.568 4.49856C9.1056 6.26208 10.7635 6.47616 11.3875 6.5568L11.4394 6.56352H18.3005C18.9965 6.56352 19.6003 7.05696 19.8864 7.77984H6.31488C4.50432 7.77984 2.70912 9.3648 2.22912 11.3875L1.63296 13.895V4.99968C1.63296 3.8064 2.42592 2.83488 3.40128 2.83488H3.40032ZM20.5296 18.8112C20.3962 19.3718 20.1005 19.8941 19.7222 20.303L19.7203 20.3011C19.2182 20.8416 18.5875 21.1642 18.0336 21.1642H3.13344C2.7696 21.1642 2.48064 21.0326 2.2752 20.7734C2.21568 20.6976 2.1648 20.6122 2.12256 20.521H2.12448C1.98144 20.2061 1.944 19.8077 2.01312 19.3843C2.01408 19.3757 2.016 19.368 2.01696 19.3594C2.02656 19.3027 2.03808 19.2461 2.05152 19.1885L3.816 11.7658C4.11936 10.4899 5.26368 9.4128 6.31488 9.4128H21.215C21.5789 9.4128 21.8669 9.54432 22.0714 9.80256C22.3642 10.1731 22.4458 10.751 22.2941 11.3875L20.5296 18.8102V18.8112ZM9.6912 17.711C9.56736 17.8666 9.38976 17.9645 9.192 17.9866C9.16416 17.9894 9.13632 17.9914 9.10848 17.9914C8.94048 17.9914 8.77824 17.9347 8.6448 17.8282L6.36672 16.0042C6.18912 15.8621 6.08736 15.6499 6.08736 15.4224C6.08736 15.1949 6.18912 14.9827 6.36672 14.8406L8.6448 13.0166C8.80032 12.8918 8.99424 12.8352 9.192 12.8582C9.38976 12.8803 9.56736 12.9782 9.6912 13.1338C9.94752 13.4544 9.89568 13.9248 9.57504 14.1811L8.02368 15.4234L9.57504 16.6656C9.89568 16.9219 9.94752 17.3923 9.6912 17.713V17.711ZM17.9136 15.4214C17.9136 15.649 17.8118 15.8611 17.6342 16.0032L15.3562 17.8272C15.2227 17.9338 15.0605 17.9904 14.8925 17.9904C14.8646 17.9904 14.8368 17.9885 14.809 17.9856C14.6112 17.9635 14.4336 17.8656 14.3098 17.7101C14.0534 17.3894 14.1053 16.919 14.4259 16.6627L15.9773 15.4205L14.4259 14.1782C14.1053 13.9219 14.0534 13.4515 14.3098 13.1309C14.4346 12.9754 14.6112 12.8774 14.809 12.8554C15.0077 12.8333 15.2016 12.8899 15.3562 13.0138L17.6342 14.8378C17.8118 14.9798 17.9136 15.192 17.9136 15.4195V15.4214ZM13.6272 12.4339L11.8051 18.8179C11.7504 19.009 11.6246 19.1683 11.4509 19.2643C11.3386 19.3267 11.2147 19.3584 11.0899 19.3584C11.0208 19.3584 10.9517 19.3488 10.8845 19.3296C10.4899 19.2163 10.2605 18.8035 10.3728 18.408L12.1949 12.024C12.2496 11.833 12.3754 11.6736 12.5491 11.5776C12.7229 11.4806 12.9245 11.4576 13.1155 11.5123C13.5101 11.6256 13.7395 12.0384 13.6272 12.4339Z"
        fill="white"
      />
    </svg>
  );
};

export const SendIcon = ({ size }: { size?: number }) => {
  return (
    <svg
      width={size || "14"}
      height={size || "14"}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.07271 8.15039L6.77731 12.1278C7.01193 12.6752 7.74166 12.7331 8.03418 12.2143C8.61141 11.1905 9.46706 9.53951 10.3227 7.40039C11.8227 3.65039 12.5727 0.650391 12.5727 0.650391M5.07271 8.15039L1.0953 6.44579C0.547857 6.21117 0.490018 5.48144 1.00883 5.18891C2.03256 4.61169 3.68359 3.75604 5.82271 2.90039C9.57271 1.40039 12.5727 0.650391 12.5727 0.650391M5.07271 8.15039L12.5727 0.650391"
        stroke="#060F30"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ShowcaseIcon = ({ size }: { size?: number }) => {
  return (
    <svg
      viewBox="0 0 21 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width={size || "21"}
      height={size || "22"}
    >
      <path
        d="M5.12259 10.0645C5.12259 10.0645 4.8125 11.3048 4.8125 13.7855C4.8125 16.2662 5.12259 17.5066 5.12259 17.5066C5.12259 17.5066 6.36295 17.1965 8.53357 15.9561C10.7042 14.7158 11.3244 13.7855 11.3244 13.7855C11.3244 13.7855 10.7042 12.8553 8.53357 11.6149C6.36295 10.3745 5.12259 10.0645 5.12259 10.0645Z"
        stroke="currentColor"
        strokeWidth="1.20324"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.6514 6.4043C14.3525 6.4043 14.8926 6.94441 14.8926 7.64551V19.75C14.8925 20.451 14.3524 20.9912 13.6514 20.9912H1.54688C0.845918 20.9911 0.305779 20.4509 0.305664 19.75V7.64551C0.305664 6.94446 0.845844 6.40437 1.54688 6.4043H13.6514ZM1.54688 7.4541C1.47749 7.45413 1.43237 7.47681 1.40527 7.50391C1.37822 7.53103 1.35645 7.57616 1.35645 7.64551V19.75C1.35649 19.8193 1.37819 19.8645 1.40527 19.8916C1.43237 19.9187 1.47753 19.9404 1.54688 19.9404H13.6514C13.7207 19.9404 13.7658 19.9187 13.793 19.8916C13.8201 19.8645 13.8427 19.8193 13.8428 19.75V7.64551C13.8428 7.57609 13.8201 7.53102 13.793 7.50391C13.7659 7.47679 13.7208 7.4541 13.6514 7.4541H1.54688ZM16.5518 3.50293C17.2529 3.50293 17.7939 4.04402 17.7939 4.74512V16.8486C17.7939 17.5497 17.2529 18.0908 16.5518 18.0908H15.7998C15.6545 18.0908 15.52 18.0415 15.4219 17.9434C15.3237 17.8452 15.2745 17.7107 15.2744 17.5654C15.2744 17.4201 15.3238 17.2857 15.4219 17.1875C15.52 17.0893 15.6545 17.0401 15.7998 17.04H16.5518C16.6212 17.04 16.6662 17.0173 16.6934 16.9902C16.7205 16.9631 16.7432 16.9181 16.7432 16.8486V4.74512C16.7432 4.6757 16.7205 4.63063 16.6934 4.60352C16.6662 4.5764 16.6212 4.55371 16.5518 4.55371H4.44824C4.37878 4.55371 4.33375 4.5764 4.30664 4.60352C4.27953 4.63063 4.25684 4.67566 4.25684 4.74512V5.49707C4.25675 5.64221 4.20735 5.7759 4.10938 5.87402C4.01115 5.97225 3.87686 6.02148 3.73145 6.02148C3.58607 6.02147 3.45173 5.97223 3.35352 5.87402C3.2556 5.77591 3.20614 5.64217 3.20605 5.49707V4.74512C3.20605 4.04402 3.74715 3.50293 4.44824 3.50293H16.5518ZM19.4531 0.602539C20.1541 0.602654 20.6943 1.14279 20.6943 1.84375V13.9482C20.6943 14.6493 20.1541 15.1893 19.4531 15.1895H18.7012C18.5558 15.1895 18.4215 15.1402 18.3232 15.042C18.2251 14.9438 18.1758 14.8094 18.1758 14.6641C18.1759 14.5189 18.2252 14.3852 18.3232 14.2871C18.4215 14.1889 18.5558 14.1396 18.7012 14.1396H19.4531C19.5225 14.1396 19.5676 14.1169 19.5947 14.0898C19.6218 14.0627 19.6436 14.0176 19.6436 13.9482V1.84375C19.6435 1.77441 19.6218 1.72925 19.5947 1.70215C19.5676 1.67507 19.5225 1.65337 19.4531 1.65332H7.34863C7.27928 1.65332 7.23416 1.67509 7.20703 1.70215C7.17994 1.72924 7.15726 1.77437 7.15723 1.84375V2.5957C7.15723 2.74112 7.108 2.8754 7.00977 2.97363C6.91155 3.07179 6.77719 3.12109 6.63184 3.12109C6.48667 3.12099 6.353 3.07166 6.25488 2.97363C6.15665 2.8754 6.10742 2.74112 6.10742 2.5957V1.84375C6.10749 1.14272 6.64758 0.602539 7.34863 0.602539H19.4531Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="0.334234"
      />
    </svg>
  );
};

export const PortfolioIcon = ({ size }: { size?: number }) => {
  return (
    <svg
      viewBox="0 0 19 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width={size || "19"}
      height={size || "20"}
    >
      <path
        d="M16.2744 1.07422L16.4873 1.08496C16.9794 1.1344 17.4421 1.35228 17.7949 1.70508C18.1982 2.10833 18.4251 2.6553 18.4258 3.22559V14.0781C18.4251 14.6484 18.1982 15.1954 17.7949 15.5986C17.4421 15.9514 16.9794 16.1693 16.4873 16.2188L16.2744 16.2295H15.7295V16.7744L15.7188 16.9873C15.6693 17.4794 15.4514 17.9421 15.0986 18.2949C14.6954 18.6982 14.1484 18.9251 13.5781 18.9258H2.72559C2.1553 18.9251 1.60833 18.6982 1.20508 18.2949C0.801828 17.8917 0.574916 17.3447 0.574219 16.7744V5.92188L0.584961 5.70898C0.634392 5.21685 0.852284 4.75417 1.20508 4.40137C1.60833 3.99812 2.1553 3.7712 2.72559 3.77051H3.27051V3.22559L3.28125 3.0127C3.33069 2.52057 3.54857 2.05787 3.90137 1.70508C4.30462 1.30184 4.8516 1.07492 5.42188 1.07422H16.2744ZM2.72559 4.74707C2.4141 4.74748 2.11577 4.87154 1.89551 5.0918C1.67525 5.31207 1.55118 5.61038 1.55078 5.92188V16.7744C1.55119 17.0859 1.67525 17.3842 1.89551 17.6045C2.11577 17.8248 2.4141 17.9488 2.72559 17.9492H13.5781L13.6943 17.9434C13.9631 17.9163 14.2155 17.7972 14.4082 17.6045C14.6285 17.3842 14.7525 17.0859 14.7529 16.7744V5.92188C14.7525 5.61037 14.6285 5.31207 14.4082 5.0918C14.2155 4.89909 13.9631 4.77995 13.6943 4.75293L13.5781 4.74707H2.72559ZM5.42188 2.05078C5.11038 2.05118 4.81207 2.17525 4.5918 2.39551C4.37154 2.61577 4.24748 2.9141 4.24707 3.22559V3.77051H13.5781C14.1484 3.7712 14.6954 3.99812 15.0986 4.40137C15.5019 4.80462 15.7288 5.35159 15.7295 5.92188V15.2529H16.2744C16.5859 15.2525 16.8842 15.1285 17.1045 14.9082C17.3248 14.6879 17.4488 14.3896 17.4492 14.0781V3.22559C17.4488 2.9141 17.3248 2.61577 17.1045 2.39551C16.8842 2.17525 16.5859 2.05119 16.2744 2.05078H5.42188Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="0.32"
      />
      <path
        d="M5.74255 7.59961C5.74255 7.59961 5.43359 8.83543 5.43359 11.3071C5.43359 13.7787 5.74255 15.0145 5.74255 15.0145C5.74255 15.0145 6.97837 14.7056 9.14105 13.4697C11.3037 12.2339 11.9216 11.3071 11.9216 11.3071C11.9216 11.3071 11.3037 10.3802 9.14105 9.14438C6.97837 7.90856 5.74255 7.59961 5.74255 7.59961Z"
        stroke="currentColor"
        strokeWidth="1.19884"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const PriceIcon = ({ size }: { size?: number }) => (
  <svg
    viewBox="0 0 29 29"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    width={size || "29"}
    height={size || "29"}
  >
    <mask
      id="path-1-outside-1_1566_10907"
      maskUnits="userSpaceOnUse"
      x="0.244629"
      y="0.203125"
      width="27"
      height="28"
      fill="black"
    >
      <rect
        fill="currentColor"
        x="0.244629"
        y="0.203125"
        width="27"
        height="28"
      />
      <path d="M25.7829 4.58102C24.8775 3.66747 23.6882 3.58146 22.439 4.28782C22.4389 3.92341 22.4242 3.64401 22.4242 3.64401C22.3878 1.96758 18.0649 1.20312 14.044 1.20312C10.0231 1.20312 5.7001 1.96758 5.66376 3.64401C5.66376 3.64401 5.64901 3.92352 5.64896 4.28811C4.39879 3.58158 3.20912 3.66777 2.30564 4.5805C1.29806 5.59621 0.989701 6.99874 1.45973 8.42901C2.01419 10.1149 3.84222 12.1016 7.3042 12.7177C7.73187 13.6083 8.26854 14.4418 8.94196 15.1473C9.81449 16.0618 10.8472 16.6782 12.0219 17.0015V19.5842H11.8273C11.2637 19.5842 10.7937 19.9884 10.7094 20.5456L10.4166 22.4794H9.8242C9.25371 22.4794 8.78947 22.9436 8.78947 23.5141V26.248C8.78947 26.8185 9.25371 27.2828 9.8242 27.2828H18.2638C18.8343 27.2828 19.2985 26.8185 19.2985 26.248V23.5141C19.2985 22.9436 18.8343 22.4794 18.2638 22.4794H17.6714L17.3786 20.5456C17.2943 19.9884 16.8242 19.5842 16.2607 19.5842H16.0661V17.0015C17.2408 16.6782 18.2735 16.0618 19.146 15.1473C19.8195 14.4418 20.3561 13.6084 20.7838 12.7177C24.2458 12.1016 26.0738 10.1149 26.6283 8.42901C27.0983 6.99874 26.7899 5.59615 25.7829 4.58102ZM14.0439 2.09005C18.9901 2.09005 21.5406 3.19353 21.5406 3.66467C21.5406 4.1358 18.9901 5.23928 14.0439 5.23928C9.09771 5.23928 6.54723 4.1358 6.54723 3.66467C6.54723 3.19353 9.09771 2.09005 14.0439 2.09005ZM2.30207 8.15183C1.94005 7.04953 2.17042 5.97554 2.93552 5.2047C3.65557 4.47857 4.57743 4.53603 5.67341 5.35941C5.74521 6.96305 6.00957 9.44068 6.87999 11.7248C4.17872 11.0781 2.74536 9.49954 2.30207 8.15183ZM18.4115 23.5141V26.248C18.4115 26.3294 18.3451 26.3958 18.2637 26.3958H9.82414C9.74275 26.3958 9.67634 26.3294 9.67634 26.248V23.5141C9.67634 23.4327 9.74275 23.3663 9.82414 23.3663H18.2637C18.3451 23.3663 18.4115 23.4327 18.4115 23.5141ZM16.502 20.6784L16.7746 22.4794H11.3133L11.5858 20.6784C11.6037 20.56 11.7076 20.4711 11.8272 20.4711H16.2606C16.3802 20.4711 16.4841 20.56 16.502 20.6784ZM15.1791 19.5841H12.9087V17.1818C13.2762 17.2342 13.6521 17.2687 14.0439 17.2687C14.4357 17.2687 14.8116 17.2342 15.179 17.1818L15.1791 19.5841ZM18.5033 14.5364C17.334 15.7611 15.8333 16.3818 14.0439 16.3818C12.2545 16.3818 10.7538 15.761 9.58447 14.5364C7.05336 11.8861 6.61265 7.05631 6.5487 4.84637C8.02279 5.71721 11.1104 6.12621 14.0439 6.12621C16.9774 6.12621 20.065 5.71727 21.539 4.84637C21.4751 7.05631 21.0345 11.8861 18.5033 14.5364ZM25.7858 8.15183C25.3425 9.4996 23.9092 11.078 21.2079 11.7248C22.0784 9.4405 22.3426 6.96293 22.4145 5.35929C23.5103 4.53573 24.4312 4.4764 25.1529 5.20523C25.9175 5.97548 26.1478 7.04953 25.7858 8.15183ZM16.9154 9.94991L15.1953 9.69989L14.4262 8.14083C14.276 7.83827 13.7806 7.83827 13.6305 8.14083L12.8613 9.69989L11.1406 9.94991C10.9731 9.97413 10.8346 10.0914 10.7826 10.2519C10.7301 10.4124 10.774 10.5885 10.8946 10.7063L12.1401 11.9195L11.8456 13.6332C11.8173 13.7995 11.8855 13.9676 12.0217 14.0669C12.0991 14.1235 12.1909 14.1518 12.2828 14.1518C12.3532 14.1518 12.4242 14.135 12.4889 14.101L14.0283 13.292L15.5671 14.101C15.7161 14.1795 15.898 14.1668 16.0337 14.0669C16.1705 13.9682 16.2386 13.7996 16.2104 13.6333L15.9165 11.9195L17.1614 10.7064C17.282 10.5886 17.3259 10.4124 17.2734 10.2519C17.2214 10.0914 17.0829 9.97413 16.9154 9.94991ZM15.1306 11.4472C15.0261 11.5488 14.9782 11.696 15.003 11.8398L15.1843 12.8977L14.2344 12.3982C14.1704 12.3642 14.0993 12.3474 14.0283 12.3474C13.9573 12.3474 13.8868 12.3642 13.8222 12.3982L12.8717 12.8977L13.0537 11.8398C13.0785 11.6961 13.0305 11.5488 12.926 11.4472L12.1575 10.6983L13.2194 10.5441C13.3643 10.5233 13.489 10.4326 13.5537 10.3016L14.0283 9.33957L14.503 10.3016C14.5677 10.4326 14.6924 10.5233 14.8373 10.5441L15.8986 10.6983L15.1306 11.4472Z" />
    </mask>
    <path
      d="M25.7829 4.58102C24.8775 3.66747 23.6882 3.58146 22.439 4.28782C22.4389 3.92341 22.4242 3.64401 22.4242 3.64401C22.3878 1.96758 18.0649 1.20312 14.044 1.20312C10.0231 1.20312 5.7001 1.96758 5.66376 3.64401C5.66376 3.64401 5.64901 3.92352 5.64896 4.28811C4.39879 3.58158 3.20912 3.66777 2.30564 4.5805C1.29806 5.59621 0.989701 6.99874 1.45973 8.42901C2.01419 10.1149 3.84222 12.1016 7.3042 12.7177C7.73187 13.6083 8.26854 14.4418 8.94196 15.1473C9.81449 16.0618 10.8472 16.6782 12.0219 17.0015V19.5842H11.8273C11.2637 19.5842 10.7937 19.9884 10.7094 20.5456L10.4166 22.4794H9.8242C9.25371 22.4794 8.78947 22.9436 8.78947 23.5141V26.248C8.78947 26.8185 9.25371 27.2828 9.8242 27.2828H18.2638C18.8343 27.2828 19.2985 26.8185 19.2985 26.248V23.5141C19.2985 22.9436 18.8343 22.4794 18.2638 22.4794H17.6714L17.3786 20.5456C17.2943 19.9884 16.8242 19.5842 16.2607 19.5842H16.0661V17.0015C17.2408 16.6782 18.2735 16.0618 19.146 15.1473C19.8195 14.4418 20.3561 13.6084 20.7838 12.7177C24.2458 12.1016 26.0738 10.1149 26.6283 8.42901C27.0983 6.99874 26.7899 5.59615 25.7829 4.58102ZM14.0439 2.09005C18.9901 2.09005 21.5406 3.19353 21.5406 3.66467C21.5406 4.1358 18.9901 5.23928 14.0439 5.23928C9.09771 5.23928 6.54723 4.1358 6.54723 3.66467C6.54723 3.19353 9.09771 2.09005 14.0439 2.09005ZM2.30207 8.15183C1.94005 7.04953 2.17042 5.97554 2.93552 5.2047C3.65557 4.47857 4.57743 4.53603 5.67341 5.35941C5.74521 6.96305 6.00957 9.44068 6.87999 11.7248C4.17872 11.0781 2.74536 9.49954 2.30207 8.15183ZM18.4115 23.5141V26.248C18.4115 26.3294 18.3451 26.3958 18.2637 26.3958H9.82414C9.74275 26.3958 9.67634 26.3294 9.67634 26.248V23.5141C9.67634 23.4327 9.74275 23.3663 9.82414 23.3663H18.2637C18.3451 23.3663 18.4115 23.4327 18.4115 23.5141ZM16.502 20.6784L16.7746 22.4794H11.3133L11.5858 20.6784C11.6037 20.56 11.7076 20.4711 11.8272 20.4711H16.2606C16.3802 20.4711 16.4841 20.56 16.502 20.6784ZM15.1791 19.5841H12.9087V17.1818C13.2762 17.2342 13.6521 17.2687 14.0439 17.2687C14.4357 17.2687 14.8116 17.2342 15.179 17.1818L15.1791 19.5841ZM18.5033 14.5364C17.334 15.7611 15.8333 16.3818 14.0439 16.3818C12.2545 16.3818 10.7538 15.761 9.58447 14.5364C7.05336 11.8861 6.61265 7.05631 6.5487 4.84637C8.02279 5.71721 11.1104 6.12621 14.0439 6.12621C16.9774 6.12621 20.065 5.71727 21.539 4.84637C21.4751 7.05631 21.0345 11.8861 18.5033 14.5364ZM25.7858 8.15183C25.3425 9.4996 23.9092 11.078 21.2079 11.7248C22.0784 9.4405 22.3426 6.96293 22.4145 5.35929C23.5103 4.53573 24.4312 4.4764 25.1529 5.20523C25.9175 5.97548 26.1478 7.04953 25.7858 8.15183ZM16.9154 9.94991L15.1953 9.69989L14.4262 8.14083C14.276 7.83827 13.7806 7.83827 13.6305 8.14083L12.8613 9.69989L11.1406 9.94991C10.9731 9.97413 10.8346 10.0914 10.7826 10.2519C10.7301 10.4124 10.774 10.5885 10.8946 10.7063L12.1401 11.9195L11.8456 13.6332C11.8173 13.7995 11.8855 13.9676 12.0217 14.0669C12.0991 14.1235 12.1909 14.1518 12.2828 14.1518C12.3532 14.1518 12.4242 14.135 12.4889 14.101L14.0283 13.292L15.5671 14.101C15.7161 14.1795 15.898 14.1668 16.0337 14.0669C16.1705 13.9682 16.2386 13.7996 16.2104 13.6333L15.9165 11.9195L17.1614 10.7064C17.282 10.5886 17.3259 10.4124 17.2734 10.2519C17.2214 10.0914 17.0829 9.97413 16.9154 9.94991ZM15.1306 11.4472C15.0261 11.5488 14.9782 11.696 15.003 11.8398L15.1843 12.8977L14.2344 12.3982C14.1704 12.3642 14.0993 12.3474 14.0283 12.3474C13.9573 12.3474 13.8868 12.3642 13.8222 12.3982L12.8717 12.8977L13.0537 11.8398C13.0785 11.6961 13.0305 11.5488 12.926 11.4472L12.1575 10.6983L13.2194 10.5441C13.3643 10.5233 13.489 10.4326 13.5537 10.3016L14.0283 9.33957L14.503 10.3016C14.5677 10.4326 14.6924 10.5233 14.8373 10.5441L15.8986 10.6983L15.1306 11.4472Z"
      fill="currentColor"
    />
    <path
      d="M25.7829 4.58102C24.8775 3.66747 23.6882 3.58146 22.439 4.28782C22.4389 3.92341 22.4242 3.64401 22.4242 3.64401C22.3878 1.96758 18.0649 1.20312 14.044 1.20312C10.0231 1.20312 5.7001 1.96758 5.66376 3.64401C5.66376 3.64401 5.64901 3.92352 5.64896 4.28811C4.39879 3.58158 3.20912 3.66777 2.30564 4.5805C1.29806 5.59621 0.989701 6.99874 1.45973 8.42901C2.01419 10.1149 3.84222 12.1016 7.3042 12.7177C7.73187 13.6083 8.26854 14.4418 8.94196 15.1473C9.81449 16.0618 10.8472 16.6782 12.0219 17.0015V19.5842H11.8273C11.2637 19.5842 10.7937 19.9884 10.7094 20.5456L10.4166 22.4794H9.8242C9.25371 22.4794 8.78947 22.9436 8.78947 23.5141V26.248C8.78947 26.8185 9.25371 27.2828 9.8242 27.2828H18.2638C18.8343 27.2828 19.2985 26.8185 19.2985 26.248V23.5141C19.2985 22.9436 18.8343 22.4794 18.2638 22.4794H17.6714L17.3786 20.5456C17.2943 19.9884 16.8242 19.5842 16.2607 19.5842H16.0661V17.0015C17.2408 16.6782 18.2735 16.0618 19.146 15.1473C19.8195 14.4418 20.3561 13.6084 20.7838 12.7177C24.2458 12.1016 26.0738 10.1149 26.6283 8.42901C27.0983 6.99874 26.7899 5.59615 25.7829 4.58102ZM14.0439 2.09005C18.9901 2.09005 21.5406 3.19353 21.5406 3.66467C21.5406 4.1358 18.9901 5.23928 14.0439 5.23928C9.09771 5.23928 6.54723 4.1358 6.54723 3.66467C6.54723 3.19353 9.09771 2.09005 14.0439 2.09005ZM2.30207 8.15183C1.94005 7.04953 2.17042 5.97554 2.93552 5.2047C3.65557 4.47857 4.57743 4.53603 5.67341 5.35941C5.74521 6.96305 6.00957 9.44068 6.87999 11.7248C4.17872 11.0781 2.74536 9.49954 2.30207 8.15183ZM18.4115 23.5141V26.248C18.4115 26.3294 18.3451 26.3958 18.2637 26.3958H9.82414C9.74275 26.3958 9.67634 26.3294 9.67634 26.248V23.5141C9.67634 23.4327 9.74275 23.3663 9.82414 23.3663H18.2637C18.3451 23.3663 18.4115 23.4327 18.4115 23.5141ZM16.502 20.6784L16.7746 22.4794H11.3133L11.5858 20.6784C11.6037 20.56 11.7076 20.4711 11.8272 20.4711H16.2606C16.3802 20.4711 16.4841 20.56 16.502 20.6784ZM15.1791 19.5841H12.9087V17.1818C13.2762 17.2342 13.6521 17.2687 14.0439 17.2687C14.4357 17.2687 14.8116 17.2342 15.179 17.1818L15.1791 19.5841ZM18.5033 14.5364C17.334 15.7611 15.8333 16.3818 14.0439 16.3818C12.2545 16.3818 10.7538 15.761 9.58447 14.5364C7.05336 11.8861 6.61265 7.05631 6.5487 4.84637C8.02279 5.71721 11.1104 6.12621 14.0439 6.12621C16.9774 6.12621 20.065 5.71727 21.539 4.84637C21.4751 7.05631 21.0345 11.8861 18.5033 14.5364ZM25.7858 8.15183C25.3425 9.4996 23.9092 11.078 21.2079 11.7248C22.0784 9.4405 22.3426 6.96293 22.4145 5.35929C23.5103 4.53573 24.4312 4.4764 25.1529 5.20523C25.9175 5.97548 26.1478 7.04953 25.7858 8.15183ZM16.9154 9.94991L15.1953 9.69989L14.4262 8.14083C14.276 7.83827 13.7806 7.83827 13.6305 8.14083L12.8613 9.69989L11.1406 9.94991C10.9731 9.97413 10.8346 10.0914 10.7826 10.2519C10.7301 10.4124 10.774 10.5885 10.8946 10.7063L12.1401 11.9195L11.8456 13.6332C11.8173 13.7995 11.8855 13.9676 12.0217 14.0669C12.0991 14.1235 12.1909 14.1518 12.2828 14.1518C12.3532 14.1518 12.4242 14.135 12.4889 14.101L14.0283 13.292L15.5671 14.101C15.7161 14.1795 15.898 14.1668 16.0337 14.0669C16.1705 13.9682 16.2386 13.7996 16.2104 13.6333L15.9165 11.9195L17.1614 10.7064C17.282 10.5886 17.3259 10.4124 17.2734 10.2519C17.2214 10.0914 17.0829 9.97413 16.9154 9.94991ZM15.1306 11.4472C15.0261 11.5488 14.9782 11.696 15.003 11.8398L15.1843 12.8977L14.2344 12.3982C14.1704 12.3642 14.0993 12.3474 14.0283 12.3474C13.9573 12.3474 13.8868 12.3642 13.8222 12.3982L12.8717 12.8977L13.0537 11.8398C13.0785 11.6961 13.0305 11.5488 12.926 11.4472L12.1575 10.6983L13.2194 10.5441C13.3643 10.5233 13.489 10.4326 13.5537 10.3016L14.0283 9.33957L14.503 10.3016C14.5677 10.4326 14.6924 10.5233 14.8373 10.5441L15.8986 10.6983L15.1306 11.4472Z"
      stroke="currentColor"
      strokeWidth="0.32098"
      mask="url(#path-1-outside-1_1566_10907)"
    />
  </svg>
);

export const LearningPathIcon = ({ size }: { size?: number }) => (
  <svg
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    width={size || "25"}
    height={size || "24"}
  >
    <g clip-path="url(#clip0_582_16808)">
      <path
        d="M4.30469 15.7432C6.20326 15.7434 7.74219 17.3596 7.74219 19.1299C7.74209 19.5834 7.56057 20.0775 7.29297 20.5615C7.02448 21.0471 6.66449 21.5322 6.29688 21.9707C5.56172 22.8474 4.78469 23.5499 4.63086 23.7012C4.53895 23.7911 4.42271 23.833 4.30371 23.833C4.21847 23.833 4.12834 23.8098 4.0498 23.7598L3.97656 23.7012C3.82106 23.5505 3.04389 22.8729 2.30957 22.0088C1.94185 21.5761 1.58187 21.0934 1.31348 20.6025C1.04581 20.113 0.865327 19.6071 0.865234 19.1299C0.865234 17.2591 2.40686 15.7432 4.30371 15.7432H4.30469ZM4.30371 16.665C2.91883 16.665 1.79785 17.7705 1.79785 19.1299C1.79795 19.3779 1.89495 19.6707 2.06445 19.9912C2.23329 20.3105 2.46981 20.6489 2.73633 20.9854C3.24256 21.6244 3.85208 22.2473 4.30469 22.7129C4.76083 22.2493 5.36305 21.7074 5.87109 21.1055C6.40572 20.472 6.80845 19.7998 6.80859 19.1299C6.80859 17.7711 5.68838 16.6653 4.30371 16.665ZM20.3438 11.498L20.3604 11.499C20.4026 11.5028 21.2897 11.5861 22.1816 12.123C23.0252 12.6309 24.0282 13.6466 24.0283 15.584V15.6846H24.0254C23.9934 17.547 23.0724 18.5495 22.293 19.0625C21.4475 19.6183 20.6041 19.7162 20.5625 19.7207L20.5635 19.7217L20.543 19.7246L20.5312 19.7256V19.7246H9.17969C8.91728 19.7246 8.70411 19.5124 8.7041 19.25C8.7041 18.9876 8.91727 18.7754 9.17969 18.7754H20.4795C20.6119 18.7567 21.2568 18.6463 21.8701 18.2041C22.4866 17.7595 23.0781 16.9744 23.0781 15.584C23.078 14.1974 22.4418 13.4246 21.7783 12.9912C21.2762 12.6633 20.7557 12.5279 20.4775 12.4756L20.29 12.4473H17.0449C16.7827 12.4471 16.5703 12.2349 16.5703 11.9727C16.5703 11.7104 16.7827 11.4983 17.0449 11.498H20.3438ZM12.501 8.49609C14.3879 8.4962 15.9227 10.0311 15.9229 11.918C15.9229 13.805 14.388 15.3397 12.501 15.3398C10.6139 15.3398 9.0791 13.8051 9.0791 11.918C9.07926 10.031 10.614 8.49609 12.501 8.49609ZM12.501 9.44531C11.1374 9.44531 10.0275 10.5544 10.0273 11.918C10.0273 13.2816 11.1373 14.3916 12.501 14.3916C13.8646 14.3915 14.9746 13.2816 14.9746 11.918C14.9744 10.5545 13.8645 9.44542 12.501 9.44531ZM13.5615 4.26758C13.8237 4.26781 14.0361 4.47992 14.0361 4.74219C14.0361 5.00445 13.8237 5.21656 13.5615 5.2168H4.92285L4.77148 5.22559C4.51839 5.24863 3.99147 5.33282 3.47363 5.63867C2.79135 6.0417 2.11133 6.83767 2.11133 8.43164C2.11147 9.81717 2.81034 10.5743 3.53906 10.9922C4.27361 11.4133 5.0398 11.4891 5.15332 11.498H8.01367C8.27598 11.4982 8.48828 11.7103 8.48828 11.9727V12.0723H8.47656C8.43078 12.2867 8.24082 12.4472 8.0127 12.4473H5.11035L5.09863 12.4463V12.4453C5.03592 12.4413 4.10163 12.3709 3.1582 11.8623C2.24921 11.3718 1.16129 10.375 1.16113 8.43164C1.16113 6.30487 2.18141 5.27447 3.0459 4.78906C3.96473 4.27321 4.87793 4.26758 4.92188 4.26758H13.5615ZM18.708 0.177734L18.8213 0.208008L18.8223 0.208984L23.7344 2.07422H23.7354C23.9815 2.16932 24.1366 2.40441 24.1367 2.66895V2.67188C24.131 2.93452 23.9629 3.16243 23.7139 3.25098H23.7129L22.627 3.62598V5.29395C22.627 5.71134 22.3952 6.09218 22.0264 6.29199C19.9058 7.45189 17.7505 7.44213 15.6396 6.27734V6.27637C15.2877 6.08434 15.0723 5.70811 15.0723 5.29883V3.6543L13.8701 3.24707V3.24609C13.618 3.16166 13.4574 2.93263 13.4463 2.67383V2.67188C13.4407 2.41088 13.5911 2.17553 13.8359 2.0752L18.3633 0.21582V0.214844C18.4737 0.16814 18.5927 0.157158 18.708 0.177734ZM19.0586 4.86816L19.0576 4.86914C18.991 4.89136 18.9192 4.90232 18.8525 4.90234C18.7851 4.90234 18.7181 4.89102 18.6523 4.86914H18.6514L15.9941 3.96582V5.29883C15.9941 5.37483 16.0344 5.44148 16.0859 5.46875H16.0879C17.9416 6.48782 19.7374 6.49313 21.5908 5.48438L21.6416 5.44629C21.6863 5.40311 21.71 5.34808 21.71 5.29395V3.94922L19.0586 4.86816ZM14.9141 2.62695L18.8584 3.96289L22.6504 2.65039L18.6045 1.1123L14.9141 2.62695Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="0.2"
      />
    </g>
    <defs>
      <clipPath id="clip0_582_16808">
        <rect
          width="24"
          height="24"
          fill="currentColor"
          transform="translate(0.5)"
        />
      </clipPath>
    </defs>
  </svg>
);
